module.exports = __webpack_public_path__ + "static/media/usa.6fa1fde4.png";